import api from "../../../api";

export const requestGetCars = () => api.get("/admin/usercars");

export const requestGetPaginationCars = (props) => {
    const query = `?${new URLSearchParams(props).toString()}`;
    return api.get(`/admin/pagination-usercars${query ? query : ""}`);
}
